module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1956")])])]), _vm._v(" "), _c('p', {
    staticClass: "LHF"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SP"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star,")]), _vm._v(" by Robert A. Heinlein")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("None")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("In 1956, Worldcon, NyCon II, was held in New York, and they chose a truly great set of Hugo winners, all of which have stood the test of time and all of which I unreservedly approve.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Best Novel award went to Robert A. Heinlein’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star,")]), _vm._v(" one of my favorite books. It’s one of Heinlein’s best novels, a future with a colonized solar system in which one down-and-out actor gets the chance to play the role of a lifetime—impersonating an important politician. It’s short, it’s engaging, it has Martians—it’s unquestionably Hugo-worthy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We don’t yet have a list of nominees. There were no other awards that year, so it’s hard to know what else people at the time thought was outstanding. Plausible nominees: Isaac Asimov’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The End of Eternity,")]), _vm._v(" Fredric Brown’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Martians Go Home,")]), _vm._v(" Arthur C. Clarke’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Earthlight,")]), _vm._v(" Frederik Pohl and Cyril Kornbluth’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gladiator-At-Law,")]), _vm._v(" C. M. Kornbluth’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Not This August,")]), _vm._v(" Naomi Mitchison’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To the Chapel Perilous,")]), _vm._v(" J. R. R. Tolkien’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Return of the King,")]), _vm._v(" and John Wyndham’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Chrysalids.")]), _vm._v(" All of these have since become classics, but I don’t think any of them are likely to have been more popular than "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In YA, there was C. S. Lewis’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Magician’s Nephew;")]), _vm._v(" two Andre Norton books, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sargasso of Space")]), _vm._v(" (under the name Andrew North) and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Star Guard;")]), _vm._v(" and Heinlein’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tunnel in the Sky.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_vm._v("I think a very good book won, and in my judgment likely the best book"), _c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-015",
      "id": "footnote-015-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" of that year.")])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("THER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ATEGORIES")]), _c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    staticClass: "fn-ref1"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnote#footnote-014",
      "id": "footnote-014-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("†")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVELETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" “Exploration Team,” by Murray Leinster")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("This was one of the first science fiction stories I read, in Amabel Williams-Ellis’s (ed.) "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tales from the Galaxies")]), _vm._v(" when I was a little kid, before I knew what science fiction was. I remember it well. Great story, but I haven’t read it lately and I haven’t heard other people talk about it much.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HORT")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("TORY")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" “The Star,” by Arthur C. Clarke")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("I think there’s a wide consensus that this is one of the best short stories ever.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Astounding,")]), _vm._v(" edited by John W. Campbell Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Again! "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Astounding")]), _vm._v(". "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star")]), _vm._v(" and “Exploration Team” appeared in it, but “The Star” appeared in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Infinity.")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RTIST")])])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Frank Kelly Freas")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AN")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Inside and Science Fiction Advertiser,")]), _vm._v(" edited by Ron Smith")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROMISING")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EW")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Robert Silverberg")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("And he’s absolutely gone on to fulfill that promise, continuing to write excellent science fiction in all the decades since.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EATURE")]), _vm._v(" W"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RITER")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Willy Ley")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OOK")]), _vm._v(" R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EVIEWER")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Damon Knight")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("New category, and what an interesting one. I had no idea. I wonder why that died out—were not enough people reviewing books? I’d suggest reviving it. (But then, I would.…) Knight was an excellent choice; his criticism is still read.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OMMENTS ON")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1956")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("1. D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EMETRIOS")]), _vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Murray Leinster just tends to be forgotten, period. I started reading SF in the seventies and went pretty in depth, yet I hadn’t really "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_32",
      "title": "32"
    }
  }, [_vm._v("heard of him until they started doing some reprints in the eighties. Unfortunately, he just didn’t seem to catch on again the way, say, Piper did.")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("4. M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ATT")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("C")]), _vm._v("I"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RVIN")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Leinster’s gotten some belated attention as the author of “A Logic Named Joe,” a 1946 story that somehow got dozens of details of today’s internet-connected, ubiquitous-computing world amazingly right—not just how they work but also how we use them and the opportunities and problems they create.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s not spot-on, since it’s basically a rogue-AI story, and some of the society’s details are very much of the story’s time, but Leinster somehow managed to figure out what a world full of networked personal computers would be like in ways that many SF writers didn’t realize until it happened.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "ch4-sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch4-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ARLIAMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("EMOCRACY WITH")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ARTIANS")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": R")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OBERT")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A. H")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("EINLEIN")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("’")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("OUBLE")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("TAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star")]), _vm._v(" may well be Heinlein’s best novel. It’s generally a useless argument to try to determine what is the very best, but I think even people with different favorites would have to agree that this one is certainly a contender. It dates from when a book could be short and still be respected—it’s barely an afternoon’s read. I have always loved it because it does everything right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There’s a first-person narrator, Lawrence Smith, aka the Great Lorenzo, a vain, out-of-work actor who is hired to go to Mars to impersonate a politician, Bonforte, in a complicated act of interplanetary diplomacy. Lorenzo writes in Heinlein’s confidential, confident voice, beginning with this pronouncement: “If a man walks in dressed like a hick and acting as if he owned the place, he’s a spaceman.” But the beauty of it is that Lorenzo is an unreliable narrator, he changes his mind as the story goes on, he is conned, he becomes not only the simulacrum "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_33",
      "title": "33"
    }
  }, [_vm._v("but the reality of Bonforte. Within the 140 pages of the novel, Lorenzo changes his mind about everything from Martians to royalty, all in that confident tone and without ever noticing that he has really changed. Everything in him changes except that most important maxim: “The show must go on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star")]), _vm._v(" has a tight, exciting plot that never stops moving; an interesting future solar system with aliens and intrigue; and down-and-dirty parliamentary politics that actually make sense. But it is as a character study that it excels. I always say that a good character brings everything else along with them—their world, because only their world could have made them, and plot, because they have to be doing something. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star")]), _vm._v(" illustrates this perfectly. I also especially like the title. I have a weakness for titles that sound one kind of science-fictional and turn out to be another kind. ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When Gravity Fails")]), _vm._v(" is another favorite example.) “Double Star” refers, of course, to Lorenzo and Bonforte, not to astronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The technology is interesting—as so often in 1950s books, the spaceships are far ahead of the computers. The thing that made me blink was the tape spools small enough to slip into your handbag that could hold ten thousand words. How writers must have longed for them in 1955! How quaint they seem now, when last week a writer friend handed me a whole novel on a flash drive small enough to get lost in the fluff at the bottom of a handbag! But as is usual for Heinlein, the explanation of what’s important about the “Farleyfile” still holds good, even though the technical details may have become obsolete. The same goes for the Martians—there are no Martians, but tolerance of diversity remains a good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I also especially commend Heinlein for seeing and noting the virtues and advantages of a parliamentary democracy with a constitutional monarchy—Heinlein was a proud American, but you can see here that he wasn’t blinkered by that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I sometimes run across people who have read some random Heinlein book and can’t understand why he dominated the genre for so long. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double Star")]), _vm._v(" is what I always suggest they read if they want to understand it. Writers can sigh at the smooth incluing, the beautiful "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_34",
      "title": "34"
    }
  }, [_vm._v("pacing, the subtlety of voice—if they can get the necessary distance to admire it without being drawn right into it. If I don’t enjoy reading it now as much as when I was a kid, that’s only because it doesn’t hold any surprises anymore.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c8a008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter4.vue
// module id = 84
// module chunks = 0